/**
 * Approvals (slice 3 §6): what the crew drafted and waits on one person to
 * approve. The card renders live from a thread's `approvals` (and, as a row,
 * on Today, slice 4b); Approve and Change it are the approver's.
 */
import { api } from "../../app/api";

import type { EmailEdit, Preview } from "../../../worker/approvals/preview";
import type { PublicApproval } from "../../../worker/approvals/public";

export type { Preview };

/** The email slots an approver may edit (slice 3 §5.1). */
export type EmailSlot = EmailEdit;

/** An approval as the routes return it: the Worker's own shape. */
export type Approval = PublicApproval;

export type EmailEdits = Partial<Record<EmailSlot, string | string[]>>;

export const approve = (id: string, edits?: EmailEdits) =>
  api<{ approval: Approval }>("POST", `/api/approvals/${id}/approve`, edits ? { edits } : {});

export const decline = (id: string, note: string | null) =>
  api<{ approval: Approval }>("POST", `/api/approvals/${id}/decline`, note ? { note } : {});
